import { render, staticRenderFns } from "./LogBuyvip.vue?vue&type=template&id=0260941a&scoped=true&"
import script from "./LogBuyvip.vue?vue&type=script&lang=js&"
export * from "./LogBuyvip.vue?vue&type=script&lang=js&"
import style0 from "./LogBuyvip.vue?vue&type=style&index=0&id=0260941a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260941a",
  null
  
)

export default component.exports